export const JOB_LINKS = {
  publicOrigins: ["https://artha.link", "https://dev.arthalink.info"],
  shortOrigins: ["https://me.artha.link", "https://me.arthalink.info"],
  apiPath: "/creators/me/job-links/shorten",
  routePath: "/me/job-links/shorten",
  maxUrls: 50,
  // Matches the server's default Express JSON body limit.
  maxRequestBytes: 100 * 1024,
  maxUrlLength: 4096,
  jobPath: /^\/@([^/]+)\/jobs\/([^/]+)\/?$/,
} as const;
